<style lang="less">
    .quick-box {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        .active {
            background-color: var(--bg-color-selected);
        }
        > div {
            &:hover {
                background-color: var(--hover-color-common-6);
            }
        }
        .all-item {
            width: 40px;
            height: 40px;
            > img {
                width: 100%;
                height: 100%;
            }
            padding: 4px;
            border-radius: 1px;
        }
        .single-item {
            > img {
                width: 24px;
                height: 24px;
            }
            border-radius: 2px;
            width: 28px;
            height: 28px;
            padding: 2px;
        }
    }
</style>

<template>
    <div class="quick-box" @mousedown.stop>
        <div
            v-for="item in themeNums"
            :class="{ 'all-item': type === 'All', 'single-item': type === 'Single', active: themeActive == item }"
            :key="item"
            @click="clickBoxItem(item)"
        >
            <img :src="quickStyleIcons[item - 1]" />
        </div>
    </div>
</template>

<script lang="ts">
    declare var Theme: any;
    import { Component, Prop, Vue } from "vue-property-decorator";

    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({})
    export default class QuickStyleBox extends Vue {
        // 初始数据可以直接声明为实例的属性、
        @Prop(String) readonly type!: string;

        get themeNums() {
            return this.type === "All" ? 56 : 48;
        }
        get childIdx() {
            return this.$store.state.ui.layoutChildIdx;
        }
        get themeActive() {
            if (this.type === "All") {
                return this.$store.state.shape.themeActive;
            } else {
                let childData = this.$store.state.ui.layoutData.childData;
                return childData[this.childIdx].quick;
            }
        }
        set themeActive(v) {
            if (this.type === "All") {
                this.$store.commit("setShapeStatus", {
                    type: "themeActive",
                    data: v,
                });
            } else {
            }
        }

        get quickStyleIcons() {
            return this.$store.state.page.quickStyleImageMap;
        }

        clickBoxItem(index) {
            let view = window["_view"];
            this.themeActive = index;
            index--;
            if (this.type === "All") {
                view.setQuickStyle(index, false);
            } else {
                view.setSmartQuickStyle(index, this.childIdx);
            }
            this.sensors.track("quickStyleSwitch", {
                Catalogues: "editFileProcess",
            });
        }
        //生命周期
        mounted() {}

        created() {}
    }
</script>
